"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _react = _interopRequireDefault(require("react"));

var _tinymce = _interopRequireDefault(require("tinymce"));

var _plugins = require("../constants/plugins");

var _controls = require("./controls");

var _EmojiToolbarButton = _interopRequireDefault(require("../components/toolbar/EmojiToolbarButton"));

var getEmojiToolbarButton = function getEmojiToolbarButton(editor) {
  return function (trackOnOpen, renderButton) {
    return _react.default.createElement(_EmojiToolbarButton.default, {
      editor: editor,
      trackOnOpen: trackOnOpen,
      renderButton: renderButton
    });
  };
};

function emojiPlugin(editor) {
  (0, _controls.addControls)(editor, getEmojiToolbarButton(editor));
}

_tinymce.default.PluginManager.add(_plugins.HS_EMOJI, emojiPlugin);